import React from 'react';
import styled from 'styled-components';

export const WhiteTile = styled((props) => <div {...props} />).attrs(
  (props) => ({
    automationid:
      props.automationid ||
      `SalesLead_div_${ props?.automationidattr?.replace(/ /g, '') }_1"`
  })
)`
  background: white;
  padding: 1.5rem;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  border-radius: ${ (props) => props.borderRadius || '4px' };

  @media (max-width: 450px) {
    padding: 0.75rem;
  }
`;
